import { getAuth } from 'firebase/auth';
import { UserSettings } from '../models/UserSettings';
import axios from 'axios';
import { FIREBASE_FUNCTION_URL } from '../app-settings';
import { UserSettingsFunctionRequest } from '../models/CloudFunction';

export async function saveUserSettings(userSettings: UserSettings): Promise<void> {
    const auth = getAuth();
    if (!auth.currentUser) {
        return Promise.reject();
    }

    const userToken = await auth.currentUser.getIdToken();
    await axios.post(`${FIREBASE_FUNCTION_URL}/saveusersettings`, userSettings, { headers: { Authorization: `Bearer ${userToken}` } });
}

export async function getUserSettings(): Promise<UserSettings> {
    const auth = getAuth();
    if (!auth.currentUser) {
        return Promise.reject("Must be authenticated to get user settings.");
    }

    const request: UserSettingsFunctionRequest<null> = {
        body: null,
        functionName: "getusersettings"
    }

    const userToken = await auth.currentUser.getIdToken();
    const response = await axios.post<UserSettings>(`${FIREBASE_FUNCTION_URL}/usersettings`, request, { headers: { Authorization: `Bearer ${userToken}` } });
    return response.data;
}

export async function getDeckFolders(): Promise<string[]> {
    const auth = getAuth();
    if (!auth.currentUser) {
        return Promise.reject("Must be authenticated to get deck folders.");
    }

    const request: UserSettingsFunctionRequest<null> = {
        body: null,
        functionName: "getdeckfolders"
    }

    const userToken = await auth.currentUser.getIdToken();
    const response = await axios.post<string[]>(`${FIREBASE_FUNCTION_URL}/usersettings`, request, { headers: { Authorization: `Bearer ${userToken}` } });
    return response.data;
}